import React, { type ReactElement } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { getMarkStatusIcon } from 'helpers/marking.helpers';
import { markStatusDisplayName } from 'pages/marking/helpers/presentation.helpers';
import { MarkStatus } from 'services/assist-api/entities/test-instance-response-mark/types';
import styles from './index.module.scss';

/**
 * Get classnames to style the mark status, excluding what is defined in the SCSS module.
 */
export const getMarkStatusBootstrapClassNames = (status: MarkStatus): string => {
  switch (status) {
    case MarkStatus.Assigned:
      return 'text-dark';
    case MarkStatus.InProgress:
      return '';
    case MarkStatus.NeedsReview:
      return 'bg-warning text-dark';
    case MarkStatus.InReview:
      return 'text-dark';
    case MarkStatus.ReturnedForMarking:
      return 'text-light';
    case MarkStatus.FurtherEscalated:
      return 'bg-danger';
    case MarkStatus.Reassigned:
      return 'text-dark';
    case MarkStatus.FinishedSuccess:
      return 'bg-success text-light';
    case MarkStatus.FinishedFailure:
      return 'text-dark';
    default:
      return 'bg-info text-light';
  }
};

/**
 * A Mark Status Badge component
 *
 * Intended use is displaying mark status
 * e.g: assigned, inProgress, needsReview, reassigned, finishedSuccess, finishedFailure
 */
export default function MarkStatusBadge({ children }: { children: MarkStatus }): ReactElement {
  return (
    <span
      className={clsx(
        'badge rounded-pill mark-status-badge',
        getMarkStatusBootstrapClassNames(children), // CSS classes from Bootstrap
        styles[children] // CSS classes from the SCSS module
      )}
    >
      <span className="me-2">{markStatusDisplayName(children)}</span>
      <FontAwesomeIcon icon={getMarkStatusIcon(children)} size="lg" />
    </span>
  );
}
